<template>
  <aside class="menu is-hidden-mobile">
    <p class="menu-label">Menu</p>
    <ul class="menu-list">
      <li>
        <router-link
          v-if="projectId || projectId != null"
          :to="{ name: 'dashboard', params: { projectId: projectId } }"
        >
          <span class="icon-text">
            <span class="icon">
              <i class="fas fa-tachometer-alt"></i>
            </span>
            <span>Dashboard</span>
          </span>
        </router-link>
      </li>
      <li>
        <router-link
          v-if="projectId || projectId != null"
          :to="{ name: 'dataList', params: { projectId: projectId } }"
        >
          <span class="icon-text">
            <span class="icon">
              <i class="fas fa-table"></i>
            </span>
            <span>Data</span>
          </span>
        </router-link>
      </li>
      <li>
        <router-link
          v-if="projectId || projectId != null"
          :to="{ name: 'eventsList', params: { projectId: projectId } }"
        >
          <span class="icon-text">
            <span class="icon">
              <i class="fas fa-file-alt"></i>
            </span>
            <span>Events</span>
          </span>
        </router-link>
      </li>
      <li>
        <router-link
          v-if="projectId || projectId != null"
          :to="{ name: 'reportDialy', params: { projectId: projectId } }"
        >
          <span class="icon-text">
            <span class="icon">
              <i class="fas fa-chart-bar"></i>
            </span>
            <span>Report</span>
          </span>
        </router-link>
      </li>
      <li>
        <router-link :to="{ name: 'projectsList' }">
          <span class="icon-text">
            <span class="icon">
              <i class="fas fa-project-diagram"></i>
            </span>
            <span>Project</span>
          </span>
        </router-link>
      </li>
      <li>
        <router-link :to="{ name: 'profileView' }" class="navbar-item">
          <span class="icon">
            <i class="fas fa-user"></i>
          </span>
          <span>Profile(MFA)</span>
        </router-link>
      </li>
      <li>
        <a href="/help/index.html" target="_blank">
          <span class="icon-text">
            <span class="icon">
              <i class="fas fa-question"></i>
            </span>
            <span>Help</span>
          </span>
        </a>
      </li>
    </ul>

    <div v-if="projectRole === 'admin'">
      <p class="menu-label mt-4">Project Admin</p>
      <ul class="menu-list">
        <li>
          <router-link
            :to="{ name: 'devicesList', params: { projectId: projectId } }"
          >
            <span class="icon-text">
              <span class="icon">
                <i class="fas fa-microchip"></i>
              </span>
              <span>Device Config</span>
              {{ " " }}
              <span v-if="errorCount > 0" class="tag is-rounded is-danger">
                {{ errorCount }}
              </span>
            </span>
          </router-link>
        </li>
        <li>
          <router-link
            :to="{ name: 'projectsView', params: { projectId: projectId } }"
          >
            <span class="icon-text">
              <span class="icon">
                <i class="fas fa-project-diagram"></i>
              </span>
              <span>Project Config</span>
            </span>
          </router-link>
        </li>
        <li>
          <router-link
            :to="{ name: 'csvDownload', params: { projectId: projectId } }"
          >
            <span class="icon-text">
              <span class="icon">
                <i class="fas fa-download"></i>
              </span>
              <span>Download</span>
            </span>
          </router-link>
        </li>
        <li>
          <router-link
            :to="{ name: 'devicesSupport', params: { projectId: projectId } }"
          >
            <span class="icon-text">
              <span class="icon">
                <i class="fas fa-medkit"></i>
              </span>
              <span>Support</span>
            </span>
          </router-link>
        </li>
        <li>
          <router-link
            :to="{ name: 'faq', params: { projectId: projectId } }"
            class="navbar-item"
          >
            <span class="icon">
              <i class="fas fa-question"></i>
            </span>
            <span>FAQ</span>
          </router-link>
        </li>
      </ul>
    </div>
    <div v-if="userRole === 'admin'">
      <p class="menu-label mt-4">Space Admin</p>
      <ul class="menu-list">
        <li>
          <router-link :to="{ name: 'projectCreate' }">
            <span class="icon-text">
              <span class="icon">
                <i class="fas fa-plus"></i>
              </span>
              <span>Create Project</span>
            </span>
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'usersList' }">
            <span class="icon-text">
              <span class="icon">
                <i class="fas fa-users"></i>
              </span>
              <span>User List</span>
            </span>
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'devicesAllList' }">
            <span class="icon-text">
              <span class="icon">
                <i class="fas fa-microchip"></i>
              </span>
              <span>Device List</span>
            </span>
          </router-link>
        </li>
      </ul>
    </div>
  </aside>
</template>

<script>
import { computed } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

export default {
  setup() {
    const store = useStore();
    const route = useRoute();
    const projectId = computed(() => {
      if (route.params.projectId) {
        return route.params.projectId;
      } else {
        return store.getters.projectId;
      }
    });

    return {
      projectId,
      projectRole: computed(() => store.getters.projectRole),
      userRole: computed(() => store.getters.userRole),
      errorCount: computed(() => store.getters.errorCount),
    };
  },
};
</script>
